import React from "react";
import "./styles/colors.less";
import { Space } from "antd";
import { AxDivider } from "@dynata/axiom3";

class Typography extends React.Component {
  render() {
    return (
      <div className="section colors" id="typography">
        <Space direction="vertical" size="large">
          <h3>Typography</h3>
          <p>
            All resources in the `dist` folder of the Axiom package are
            framework agnostic, which means they could be imported and used
            outside React projects.
            <br />
            This section describes Axiom typography classes usage. The
            texts/labels in the rendered examples below, are to be used as class
            names for your html elements.
          </p>

          <AxDivider orientation="left" plain>
            Usage: typography.css
          </AxDivider>

          <ul>
            <li>
              Import typography.css in your project's CSS file:
              <br />
              <code className="inline">
                @import "@dynata/axiom3/dist/typography.css"
              </code>
            </li>

            <li>
              Usage example:
              <br />
              <code className="inline">
                {`<p className="headline light l">headline light l</p>`}
              </code>
            </li>
          </ul>

          {/* <p>
            <b>Note:</b> The inner-html text below for each typography style is
            a className, which can be used as is:
            <br />
            <code className="inline">
              {`<p className="headline light l">headline light l</p>`}
            </code>
          </p> */}
        </Space>

        <AxDivider orientation="left" plain>
          Title
        </AxDivider>

        <Space align="start" size={[32, 32]} wrap>
          <div>
            <p className="title all-caps xs">title all-caps xs</p>
            <p className="title all-caps s">title all-caps s</p>
            <p className="title all-caps xs">title all-caps xs</p>
          </div>
          <div>
            <p className="title light xs">title light xs</p>
            <p className="title light s">title light s</p>
            <p className="title light m">title light m</p>
            <p className="title light l">title light l</p>
            <p className="title light xl">title light xl</p>
            <p className="title light xxl">title light xxl</p>
          </div>

          <div>
            <p className="title regular xs">title regular xs</p>
            <p className="title regular s">title regular s</p>
            <p className="title regular m">title regular m</p>
            <p className="title regular l">title regular l</p>
            <p className="title regular xl">title regular xl</p>
            <p className="title regular xxl">title regular xxl</p>
          </div>

          <div>
            <p className="title semibold xs">title semibold xs</p>
            <p className="title semibold s">title semibold s</p>
            <p className="title semibold m">title semibold m</p>
            <p className="title semibold l">title semibold l</p>
            <p className="title semibold xl">title semibold xl</p>
            <p className="title semibold xxl">title semibold xxl</p>
          </div>

          <div>
            <p className="title bold xs">title bold xs</p>
            <p className="title bold s">title bold s</p>
            <p className="title bold m">title bold m</p>
            <p className="title bold l">title bold l</p>
            <p className="title bold xl">title bold xl</p>
            <p className="title bold xxl">title bold xxl</p>
          </div>
        </Space>

        <AxDivider orientation="left" plain>
          Headline
        </AxDivider>

        <Space align="start" size={[32, 32]} wrap>
          <div>
            <p className="headline light xs">headline light xs</p>
            <p className="headline light s">headline light s</p>
            <p className="headline light m">headline light m</p>
            <p className="headline light l">headline light l</p>
            <p className="headline light xl">headline light xl</p>
            <p className="headline light xxl">headline light xxl</p>
          </div>

          <div>
            <p className="headline regular xs">headline regular xs</p>
            <p className="headline regular s">headline regular s</p>
            <p className="headline regular m">headline regular m</p>
            <p className="headline regular l">headline regular l</p>
            <p className="headline regular xl">headline regular xl</p>
            <p className="headline regular xxl">headline regular xxl</p>
          </div>

          <div>
            <p className="headline semibold xs">headline semibold xs</p>
            <p className="headline semibold s">headline semibold s</p>
            <p className="headline semibold m">headline semibold m</p>
            <p className="headline semibold l">headline semibold l</p>
            <p className="headline semibold xl">headline semibold xl</p>
            <p className="headline semibold xxl">headline semibold xxl</p>
          </div>

          <div>
            <p className="headline bold xs">headline bold xs</p>
            <p className="headline bold s">headline bold s</p>
            <p className="headline bold m">headline bold m</p>
            <p className="headline bold l">headline bold l</p>
            <p className="headline bold xl">headline bold xl</p>
            <p className="headline bold xxl">headline bold xxl</p>
          </div>
        </Space>

        <AxDivider orientation="left" plain>
          Body
        </AxDivider>

        <Space align="start" size={[32, 32]} wrap>
          <div>
            <p className="body light xs">body light xs</p>
            <p className="body light s">body light s</p>
            <p className="body light m">body light m</p>
            <p className="body light l">body light l</p>
          </div>

          <div>
            <p className="body regular xs">body regular xs</p>
            <p className="body regular s">body regular s</p>
            <p className="body regular m">body regular m</p>
            <p className="body regular l">body regular l</p>
          </div>

          <div>
            <p className="body semibold xs">body semibold xs</p>
            <p className="body semibold s">body semibold s</p>
            <p className="body semibold m">body semibold m</p>
            <p className="body semibold l">body semibold l</p>
          </div>

          <div>
            <p className="body bold xs">body bold xs</p>
            <p className="body bold s">body bold s</p>
            <p className="body bold m">body bold m</p>
            <p className="body bold l">body bold l</p>
          </div>
        </Space>

        <AxDivider orientation="left" plain>
          Metric
        </AxDivider>

        <Space align="start" size={[32, 32]} wrap>
          <div>
            <p className="metric xs">metric xs</p>
            <p className="metric s">metric s</p>
            <p className="metric m">metric m</p>
            <p className="metric l">metric l</p>
            <p className="metric xl">metric xl</p>
          </div>
        </Space>
      </div>
    );
  }
}
export default Typography;
